<template>
  <div class="col-12 grid">
    <VueConfirmDialog :parent="_uid" />
    <div class="row">
      <div v-if="showTitle" :class="{ 'col-sm-6': !fullWidth }" class="col-12 head flex-container">
        WHAT'S IN MY RUX?
        <div @click="deleteAllPackingListItems()" class=" material-symbols-outlined deleteAll pointer">
          delete_forever
        </div>
      </div>
      <div v-if="showTitlePackingList" :class="{ 'col-sm-6': !fullWidth }" class="col-12 head">
        ITEMS
      </div>
      <div :class="{ 'col-sm-6': !fullWidth }" class="col-12 no-padding push-down-10">
        <div class="container">
          <div v-if="!readOnly" class="entry-container">
            <div class="input-div">
              <input placeholder="Add a new item..." type="text" class="form-control" v-model="newPackingListItem"
                @keyup.enter="addNewPackingListItem" />
            </div>
            <div class="no-padding">
              <div @click="addNewPackingListItem()" class="material-symbols-outlined pointer add">
                add
              </div>
            </div>
          </div>
          <div v-if="showSelect" class="row packing-list-item ">
            <div class="select-all-wrapper">
              <input class="pointer" @input="handleChangeAll" type="checkbox" :checked="allChecked" /><span
                v-if="!readOnly" class="select-all">Check all items as packed</span>
              <span v-else class="select-all">Select all items</span>
            </div>
          </div>
          <div class="container packing-list-items-wrapper no-padding">
            <transition-group name="change-item" enter-active-class="animation fadeIn"
              leave-active-class="animation fadeOut">
              <div class="row packing-list-item border-bottom" v-for="(item, index) in items" :key="index">
                <div v-if="showSelect">
                  <input class="pointer item-checkbox" @input="handleCheckboxInput($event.target.checked, index)"
                    type="checkbox" :checked="item.checked" />
                </div>
                <div class="bullet-point" v-if="!showSelect">
                  &#9632; &nbsp;
                </div>
                <div :data-testid="'item-' + index" class="list-item pointer"
                  @click="handleCheckboxInput(!item.checked, index)">
                  {{ item.value }}
                </div>

                <div v-if="!readOnly" @click="deletePackingListItem(index)" class="
                    material-symbols-outlined
                    delete
                    pointer
                  ">
                  delete
                </div>
              </div>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { mapState } from 'vuex'
import VueConfirmDialog from './ConfirmDialog/vue-confirm-dialog'
// Displays the packing list items.
export default {
  name: 'PackingList',
  components: { VueConfirmDialog },
  data: function () {
    return {
      // Used as the v-model when adding a new item
      newPackingListItem: null,
    }
  },
  props: ['items', 'fullWidth', 'showTitle', 'showTitlePackingList', 'readOnly', 'showSelect'],
  computed: {
    allChecked() {
      return this.getSelectedItems.length === this.itemsWithIndex.length
    },
    getDeselectedItems() {
      return this.itemsWithIndex.filter((item) => !item.checked)
    },
    getSelectedItems() {
      return this.itemsWithIndex.filter((item) => item.checked)
    },
    itemsWithIndex() {
      if (Array.isArray(this.items) && this.items.length > 0) {
        return this.items.map((item, index) => {
          return {
            ...item,
            index,
          }
        })
      } else {
        return []
      }
    },
  },
  methods: {
    // Get fresh data.
    async getRux(serialNumber) {
      this.$store.dispatch('rux/getRux', serialNumber)
    },
    // Adds a new packing list item to the array
    async addNewPackingListItem() {
      // Make sure the user has entered some text
      if (this.newPackingListItem) {
        // Fire the add event and let the parent handle everything else.
        this.$emit('add', this.newPackingListItem)
        // Clear the text box after
        this.newPackingListItem = null
      }
    },
    handleCheckboxInput(event, index) {
      this.$emit('update', { value: event, index })
    },
    handleChangeAll() {
      if (this.allChecked) {
        this.getSelectedItems.forEach((item) => {
          this.$emit('update', { value: false, index: item.index })
        })
      } else {
        this.getDeselectedItems.forEach((item) => {
          this.$emit('update', { value: true, index: item.index })
        })
      }
    },
    // Deletes a packing list item
    deletePackingListItem(index) {
      // Show a confirm dialog so people don't delete stuff with fat thumbs
      this.$confirm({
        message: 'Really delete packing list item? This cannot be undone',
        buttons: [
          {
            text: 'Cancel',
          },
          {
            text: 'Delete',
            callback: () => {
              const item = this.items[index]
              //Emit the delete event with the index and item
              this.$emit('delete', { item, index })
            },
          },
        ],
        parent: this._uid,
      })
    },
    deleteAllPackingListItems() {
      this.$confirm({
        message: 'Really delete all items? This cannot be undone',
        buttons: [
          {
            text: 'Cancel',
          },
          {
            text: 'Delete All',
            callback: () => {
              this.$emit('deleteAll')
            },
          },
        ],
        parent: this._uid,
      })
    },
  },
}
</script>

<style lang='scss' scoped>
input[type='checkbox'] {
  width: 1rem;
  height: 1rem;
}
input {
  border-radius: 0px;
}
.border-bottom {
  border-bottom: solid 0.5px darkgray;
}
.list-item {
  top: -3px;
  display: flex;
  flex-grow: 1;
  position: relative;
}
.item-checkbox {
  margin-right: 13px;
}
.bullet-point {
  top: -3px;
  position: relative;
  margin-right: 13px;
}
.container {
  font-family: "Neue Roman";
}
.entry-container {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: row;
}
.input-div {
  display: flex;
  flex-grow: 1;
}
div.grid {
  border-bottom: none !important;
  .no-padding {
    padding: 0px;
  }
  .head {
    font-size: large;
    font-weight: bold;
    text-align: left;
    padding-bottom: 8px;
    @include respond-to('sm') {
      font-weight: normal;
      padding-bottom: 0px;
    }
  }
  .add {
    position: relative;
    top: 0.25rem;
    font-size: 2rem;
    color: black;
    left: 0.25rem;
  }
  input.form-control {
    width: 100%;
    margin: 0;
    height: 40px;
    box-shadow: none;
    border: 0.05rem solid black;
    border-radius: 2px;
  }
  .packing-list-items-wrapper {
    width: 100%;
    @include respond-to('md') {
      width: 100% !important;
    }
  }
  .packing-list-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: 8px;
    padding-bottom: 0px;
    text-align: left;
    margin: 0px;
    margin-right: 0px;
    font-size: 16px;
    flex-wrap: nowrap;
    width: 100%;
    .delete {
      font-size: 1.5rem;
      color: black;
      position: relative;
      top: -4px;
    }
  }
  .deleteAll {
    font-size: 1.5rem;
    color: black;
    position: relative;
    top: px;
  }
  .flex-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.animation {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.select-all-wrapper {
  margin-top: 5px;
  display: flex;
  align-items: center;
  .select-all {
    margin-left: 13px;
    font-size: 12px;
    font-family: "Neue Roman";
  }
}
</style>